module.exports = __webpack_public_path__ + "img/bg-numbers.e7d7200a.webp";